module.exports = __webpack_public_path__ + "static/media/new-jersey.b63cadb4.png";